// Shared payment-method options used across:
//   - Student Accounts (Add Record / Pay dialogs)
//   - Accounting -> Income / Expenses
//   - Cash Analysis -> Fund Transfer
//   - Employee Salary "Mark as Paid" dialog
//
// The backend Literal still accepts legacy values (gcash, maya) so historical
// rows continue to display. `formatMode` covers those legacy labels too.

export const PAYMENT_MODES = [
  { value: "cash", label: "Cash" },
  { value: "online", label: "Online Payment" },
  { value: "bank_transfer", label: "Bank Transfer" },
  { value: "card", label: "Debit/Credit Card" },
  { value: "check", label: "Checks" },
  { value: "other", label: "Other" },
];

const LEGACY_LABELS = {
  gcash: "GCash",
  maya: "Maya",
};

export function formatMode(m) {
  if (!m) return "—";
  const hit = PAYMENT_MODES.find((p) => p.value === m);
  if (hit) return hit.label;
  if (LEGACY_LABELS[m]) return LEGACY_LABELS[m];
  return m[0].toUpperCase() + m.slice(1);
}
